import React from 'react';
import GruShell from '../../components/gru/GruShell';
import TabellaArticoli from './components/TabellaArticoli';

// /gru-magazzino — articoli, giacenze, carico e rettifica
const GruMagazzinoPage = () => (
  <GruShell indietroA="/gru-inventory">
    <TabellaArticoli />
  </GruShell>
);

export default GruMagazzinoPage;
